<template>
<action-sidebar
	title="Asignar Categoria"
	:value="true"
	@close-modal="closeModal"
	>
	<div class="px-3 pt-4">
		<v-flex xs12 mb-4>
			<v-select
			background-color="white"
			box
			class="body-1"
			hide-details
			item-text="name"
			item-value="name"
			label="Tipo de Integración"
			v-model="model.typeIntegration"
			:items="typeIntegrations"
			return-object
			@input="setValue"
			></v-select>
			<span class="form-group__message" v-if="!$v.model.typeIntegration.required">
				Seleccione un Tipo de Integración.
			</span>
		</v-flex>
		<v-layout>
			<v-flex xs9 mb-4>
				<v-select
				background-color="white"
				box
				:disabled="false"
				class="body-1"
				hide-details
				item-text="name"
				item-value="name"
				label="Categorías"
				v-model="model.category"
				:items="categories"
				return-object
				></v-select>
			</v-flex>
			<v-flex xs3>
				<v-btn
					:disabled="$v.$invalid"
					color="primary"
					@click="assignCategory"
				>
					Asignar
					<v-icon>add</v-icon>
				</v-btn>
			</v-flex>
		</v-layout>
		<app-table
		name="table-assign-category"
		class="mt-2"
		:columns="columns"
		:rows="rows"
		:input-search="false"
		>
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable" v-show="showRow(columns, 1)">{{ props.row.name }}</td>
				<td v-show="showRow(columns, 2)">{{ props.row.nameTypeIntegration }}</td>
				<td v-show="showRow(columns, 3)">
					<v-layout row justify-center>
						<v-flex xs2>
							<app-tooltip-button
								color="error"
								icon="delete"
								text="Elimimar"
								@click-icon="openDialog(props.row)"
							/>
						</v-flex>
						<v-flex xs2>
							<v-tooltip top>
								<v-switch
									slot="activator"
									color="green"
									class="ml-3 mt-0"
									hide-details
									v-model="props.row.flagActive"
								></v-switch>
								<span>{{ labelState(props.row.flagActive) }}</span>
							</v-tooltip>
						</v-flex>
					</v-layout>
				</td>
			</template>
		</app-table>
		<v-dialog v-model="dialog" persistent max-width="500">
			<v-card>
				<v-card-title class="subheading">{{ dialogMessage }}</v-card-title>
				<v-card-actions class="justify-center">
					<v-btn
						class="btn-action"
						color="green"
						dark
						@click.native="deleteCategory"
					>
						SI
					</v-btn>
					<v-btn
						class="btn-action"
						color="error"
						dark
						@click.native="closeDialog"
					>
						NO
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="false"
				success-text="Guardar"
				@accept-button-clicked="saveCategory"
				@cancel-button-clicked="closeModal"
			></modal-sidebar-button>
		</section>
	</div>
</action-sidebar>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import { required } from 'vuelidate/lib/validators';
import actionSidebar from '@/components/shared/action-sidebar';

function created() {
	this.loadTypeIntegration();
	this.loadEditCategory();
}

async function loadEditCategory() {
	try {
		const idProcess = this.$route.params.idProcess;
		const codeTemplate = this.$route.params.codeTemplate;
		const response = await this.$http.get(`process/${idProcess}/template/${codeTemplate}`);
		this.rows = response.data.data.categories;
	} catch (error) {
		if (error.status === 405) {
			if (error.data.message === 'PROCESS_WITHOUT_CONFIGURED_DATA') {
				this.showError('Usted no tiene configurado el proceso.');
			}
		} else {
			this.showError();
		}
	}
}

function setValue(row) {
	this.loadCategories(row.id);
}

function assignCategory() {
	const newobj = {
		codeTypeIntegration: this.model.typeIntegration.code,
		nameTypeIntegration: this.model.typeIntegration.name,
		code: this.model.category.code,
		name: this.model.category.name || this.model.category,
		flagActive: false,
	};
	const index = this.rows.findIndex(r => r.code === this.model.category.code
		&& r.codeTypeIntegration === this.model.typeIntegration.code);
	if (index > -1) {
		this.showError('Ya tiene asociada la categoría.');
	} else {
		this.rows.push(newobj);
	}
	this.clearForm();
}

function openDialog(row) {
	this.dialogMessage = `¿Desea eliminar la categoria '${row.name}'?`;
	this.idCategory = row.id;
	this.dialog = true;
}

function deleteCategory() {
	const index = this.rows.findIndex(r => r.id === this.idCategory);
	if (index > -1) {
		this.rows.splice(index, 1);
		this.showNotification('La categoria fue eliminada correctamente.');
		this.closeDialog();
	}
}

function labelState(value) {
	return value ? 'Activar Categoria' : 'Desactivar Categoria';
}

function closeDialog() {
	this.dialog = false;
	this.idCategory = null;
	this.dialogMessage = '';
}

async function loadTypeIntegration() {
	try {
		const response = await this.$http.get('type-integrations');
		this.typeIntegrations = response.data.data;
		if (this.typeIntegrations.length === 1) {
			this.model.typeIntegration = this.typeIntegrations[0];
			this.loadCategories(this.typeIntegrations[0].id);
		}
	} catch (error) {
		this.showError();
	}
}

async function loadCategories(idTypeIntegration) {
	const params = {
		typeIntegrationId: idTypeIntegration,
		templateCode: this.$route.params.codeTemplate,
	};
	try {
		const response = await this.$http.get('categories', { params });
		this.categories = response.data.data;
		if (this.categories.length === 1) {
			this.model.category = this.categories[0];
		}
	} catch (error) {
		if (error.status === 405) {
			if (error.data.message === 'TYPE_CATEGORY_NOT_FOUND') {
				this.showError('Debe asignar una intregación.');
			}
		} else {
			this.showError();
		}
	}
}

function clearForm() {
	this.model = {
		typeIntegration: null,
		category: null,
	};
}

function closeModal() {
	this.goTo('page-configuration-process');
}

function validations() {
	return {
		model: {
			typeIntegration: { required },
			category: { required },
		},
	};
}

async function saveCategory() {
	const body = {
		categories: this.rows.map((e) => {
			const newObj = {};
			newObj.codeTypeIntegration = e.codeTypeIntegration;
			newObj.nameTypeIntegration = e.nameTypeIntegration;
			newObj.flagActive = e.flagActive;
			newObj.code = e.code;
			newObj.name = e.name;
			return newObj;
		}),
	};
	const idProcess = this.$route.params.idProcess;
	const codeTemplate = this.$route.params.codeTemplate;
	try {
		await this.$http.patch(`process/${idProcess}/template/${codeTemplate}`, body);
		this.closeModal();
	} catch (error) {
		this.showError();
	}
}

function data() {
	return {
		idCategory: null,
		categories: [],
		columns: [
			{ id: 1, name: 'Categoria', value: 'category', checked: true, visible: true },
			{ id: 2, name: 'Tipo de Integración', value: 'typeIntegration', checked: true, visible: true },
			{ id: 3, name: 'Acciones', checked: true, visible: true },
		],
		dialogMessage: '',
		dialog: false,
		model: {
			id: null,
			typeIntegration: null,
			category: null,
		},
		rows: [],
		typeIntegrations: [],
	};
}

export default {
	name: 'page-configuration-process-integration-category',
	data,
	created,
	methods: {
		assignCategory,
		clearForm,
		closeModal,
		closeDialog,
		deleteCategory,
		openDialog,
		loadEditCategory,
		labelState,
		loadCategories,
		loadTypeIntegration,
		saveCategory,
		setValue,
	},
	components: {
		appTooltipButton,
		actionSidebar,
	},
	validations,
};
</script>


// WEBPACK FOOTER //
// src/components/process/page-configuration-process-integration-category.vue